export default function getInitState() {
    return {
        patientWaitingTableIsShow: true,
        patientWaitingDisbandIsShow: false,
        patientAttendanceTableIsShow: false,
        patientAttendanceDetailsIsShow: false,
        occupationHealthDoctorAppointmentIsShow: false,

        patientWaitingTableAdditionalConfig: {
            per_page: 5
        },

        patientWaitingTableRowActions: [
            {
                btn_text: '<i class="far fa-folder"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showDetails'
            },
            {
                btn_text: '<i class="far fa-money-bill-alt"></i>',
                title: 'Elbocsátás/Fizetés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'disbandPatient'
            },
            {
                btn_text: '<i class="fas fa-file-medical-alt"></i>',
                title: 'Adatlap megtekintése',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'showPatientBasicDataSheet'
            }
        ],
        patientWaitingTableAppointmentRowActions: [
            {
                btn_text: '<i class="fas fa-arrow-down"></i>',
                title: 'Megérkezett',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                event_payload: 'setStatusArrived'
            },
        ],
        patientWaitingTableHeaderFields: [
            {
                label: "Azonosító",
                name: "id",
                visibility: false
            },
            {
                label: "Sorszám",
                name: "ticketNumber"
            },
            {
                label: "Név",
                name: "patient.name",
                filter: {
                    type: "simple",
                },
                sort: true
            },
            {
                label: "Telefonszám",
                name: "patient.phoneNumber",
                filter: {
                    type: "simple",
                },
                sort: true
            },
            {
                label: "Időpont",
                name: "appointment",
                filter: {
                    type: "simple",
                },
                slot_name: "appointment_format",
                sort: true
            },
            {
                label: "Orvos",
                name: "doctor.fullName",
                filter: {
                    type: "simple",
                },
                sort: true
            },
            {
                label: "Szoba",
                name: "room.name",
                filter: {
                    type: "simple",
                },
                sort: true
            },
            {
                label: "Kezelés",
                name: "treatment.title",
                filter: {
                    type: "simple",
                },
                sort: true
            },
            {
                label: "Állapot",
                name: "appointmentStatus.text",
                filter: {
                    type: "simple",
                },
                sort: true,
            },
            {
                label: "Opciók",
                name: "buttons",
                sort: false
            }
        ]
    }
}
